<template>
	<div
		class="fixed z-10 inset-0 overflow-y-auto"
		aria-labelledby="modal-title"
		role="dialog"
		aria-modal="true"
	>
		<div
			class="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0"
		>
			<transition name="fade">
				<div
					class="fixed inset-0 bg-gray-700 bg-opacity-75 transition-opacity"
					aria-hidden="true"
					v-if="open"
					ref="overlay"
					v-on:click="close()"
				></div>
			</transition>

			<!-- This element is to trick the browser into centering the modal contents. -->
			<span
				class="hidden sm:inline-block sm:align-middle sm:h-screen"
				aria-hidden="true"
				>&#8203;</span
			>

			<transition name="zoomin">
				<div
					class="inline-block align-middle bg-white rounded-2xl text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full md:max-w-screen-md"
				>
					<slot name="full-content">
						<div class="bg-green-500 px-6 py-4 text-white">
							<div class="flex justify-between items-baseline pr-4 mr-6">
								<h2 class="text-4xl font-bold">
									{{ __("Die neue Auktion auf cropspot") }}
								</h2>
							</div>

							<ui-button
								type="blank"
								class="absolute right-5 top-5"
								v-if="open"
								v-on:click="close()"
							>
								<ui-icon class="h-9 w-9 text-white" name="x" stroke-width="2" />
							</ui-button>
						</div>
						<div :style="getBackgroundCSS" class="p-6">
							<div class="flex items-start justify-start">
								<div
									class="my-4 inline-block w-1/2 pb-8 pr-7"
									:style="getBoxBackgroundCSS()"
								>
									<p class="bg-white p-5 text-base font-medium">
										Sie wollen vermarkten, sind sich aber unsicher über den
										fairen Marktpreis?
									</p>
								</div>
							</div>
							<div class="flex items-center justify-center">
								<div
									class="my-4 inline-block w-1/2 pb-8 pr-7"
									:style="getBoxBackgroundCSS('orange')"
								>
									<p class="bg-white p-5 text-base font-medium">
										Sie wollen wissen, ob Ihre örtlichen Händler den besten
										Preis für Ihre Ware bieten?
									</p>
								</div>
							</div>
							<div class="flex items-end justify-end">
								<div
									class="my-4 inline-block w-1/2 pb-8 pr-7"
									:style="getBoxBackgroundCSS('black')"
								>
									<p class="bg-white p-5 text-base font-medium">
										Sie wollen den Markt testen und Ihre Zielpreise erreichen?
									</p>
								</div>
							</div>
						</div>
						<div class="p-6">
							<div class="sm:flex sm:items-start">
								<div class="mt-4 text-center sm:mt-0 sm:ml-4 sm:text-left">
									<h3 class="text-2xl font-bold text-center my-5">
										Wir bieten Ihnen jetzt mit der Auktion auf cropspot eine
										neue, spannende Antwort auf diese Fragen!
									</h3>
									<img :src="auctionHammerUrl" class="inline" />
									<h3 class="text-2xl text-orange font-bold my-8 ml-2 inline">
										So läuft unsere Auktion ab
									</h3>
									<ol class="relative mt-4">
										<li
											class="pb-4 border-l-4 border-orange pl-12"
											style="margin-left: 27px"
										>
											<span
												class="flex absolute justify-center items-center bg-orange rounded-full left-4"
												style="width: 30px; height: 30px"
											>
												<span
													class="bg-white rounded-full text-orange text-2xl text-center font-bold"
													style="width: 28px; height: 28px"
													>1</span
												>
											</span>
											<div class="bg-gray-100 p-5 rounded-xl shadow">
												<h3
													class="mb-2 text-lg font-semibold text-gray-900 dark:text-white leading-4"
												>
													Bereitstellen
												</h3>
												<p class="pb-2 text-base font-normal">
													Jede Woche Mittwoch ist bei cropspot Auktionstag. Ab
													Montag 07:00 Uhr haben Sie die Möglichkeit aus Ihren
													Verkaufsinseraten eine (Teil-) Menge im Auktionsraum
													zu platzieren. Gleichzeitig legen Sie auch einen
													Zielpreis fest, zu welchem Sie verbindlich bereit
													wären, Ihre Ware zu verkaufen. Bis Mittwoch 14:00 Uhr
													können sie Ihre Eingaben jederzeit ändern oder
													löschen.
												</p>
												<p class="pb-2 text-base font-normal">
													Sind Sie sich über die Höhe des Zielpreises unsicher,
													zögern Sie nicht mit uns Kontakt aufzunehmen.
												</p>
											</div>
										</li>
										<li
											class="pb-4 border-l-4 border-orange pl-12"
											style="margin-left: 27px"
										>
											<span
												class="flex absolute justify-center items-center bg-orange rounded-full left-4"
												style="width: 30px; height: 30px"
											>
												<span
													class="bg-white rounded-full text-orange text-2xl text-center font-bold"
													style="width: 28px; height: 28px"
													>2</span
												>
											</span>
											<div class="bg-gray-100 p-5 rounded-xl shadow">
												<h3
													class="mb-2 text-lg font-semibold text-gray-900 dark:text-white leading-4"
												>
													Auktionseröffnung
												</h3>
												<p class="pb-2 text-base font-normal">
													Ab Mittwoch 14:00 Uhr können geprüfte und verifizierte
													Käufer die Auktionsangebote einsehen. Zielpreise
													werden verdeckt gehalten. Die Käufer haben bis 15:00
													Uhr Zeit für ihre gewünschten Auktionsangebote einen
													Kaufpreis zu ermitteln.
												</p>
											</div>
										</li>
										<li
											class="pb-4 border-l-4 border-orange pl-12"
											style="margin-left: 27px"
										>
											<span
												class="flex absolute justify-center items-center bg-orange rounded-full left-4"
												style="width: 30px; height: 30px"
											>
												<span
													class="bg-white rounded-full text-orange text-2xl text-center font-bold"
													style="width: 28px; height: 28px"
													>3</span
												>
											</span>
											<div class="bg-gray-100 p-5 rounded-xl shadow">
												<h3
													class="mb-2 text-lg font-semibold text-gray-900 dark:text-white leading-4"
												>
													Bietverfahren
												</h3>
												<p class="pb-2 text-base font-normal">
													Von 15:00 Uhr bis 16:00 Uhr können Käufer Preise
													abgeben. Die Zielpreise bleiben weiterhin verdeckt.
													Auf diese Weise erreichen wir ein möglichst
													unvoreingenommenes Bietverhalten der
													Kaufinteressenten.
												</p>
											</div>
										</li>
										<li
											class="pb-4 border-l-4 border-orange pl-12"
											style="margin-left: 27px"
										>
											<span
												class="flex absolute justify-center items-center bg-orange rounded-full left-4"
												style="width: 30px; height: 30px"
											>
												<span
													class="bg-white rounded-full text-orange text-2xl text-center font-bold"
													style="width: 28px; height: 28px"
													>4</span
												>
											</span>
											<div class="bg-gray-100 p-5 rounded-xl shadow">
												<h3
													class="mb-2 text-lg font-semibold text-gray-900 dark:text-white leading-4"
												>
													Auktionsende
												</h3>
												<p class="pb-2 text-base font-normal">
													Um 16 Uhr schließt das Bietverfahren und die Gebote
													werden ausgewertet. Für Sie können sich folgende
													Ergebnisse ergeben:
												</p>
												<p class="pb-2 text-base font-normal">
													<strong>a)</strong> Wenn ein Käufer mindestens Ihren
													Zielpreis bietet, kommt es automatisch zu einem
													verbindlichen Kontrakt.
												</p>
												<p class="pb-2 text-base font-normal text-gray-400">
													<strong class="text-gray-500">Beispiel:</strong> Ihr
													Zielpreis war für 50 Tonnen 230 €/t ab Hof und ein
													Händler hat in der Auktion als Höchstbietender 232 €/t
													geboten. Nach Ende der Auktion wird auf cropspot
													automatisch ein Kontrakt zu dem vom Händler gebotenen
													Preis, in dem Fall 232 €/t, geschlossen.
												</p>
												<p class="pb-2 text-base font-normal">
													<strong>b)</strong> Wenn kein Käufer mindestens Ihren
													Zielpreis bietet, erhalten Sie zum Ende der Auktion
													ein Gebot in den cropspot-Verhandlungen mit dem Preis
													des Höchstbietenden. Sollte Ihr Zielpreis zu weit vom
													Marktpreis entfernt sein, haben Sie hier die
													Möglichkeit noch einmal in Verhandlungen zu treten.
												</p>
												<p class="pb-2 text-base font-normal text-gray-400">
													<strong class="text-gray-500">Beispiel:</strong> Ihr
													Zielpreis war für 50 Tonnen 230 €/t ab Hof. Der
													höchste Preis für Ihr Angebot war 228 €/t. Sie
													erhalten nun lediglich von diesem Käufer ein 30
													Minuten gültiges Angebot auf cropspot mit dem Preis
													von 228 €/t. Die Entscheidung, ob Sie das Angebot
													annehmen, ablehnen oder einen anderen Preis
													verhandeln, liegt bei Ihnen.
												</p>
											</div>
										</li>
										<li
											class="pb-4 border-l-4 border-white pl-12"
											style="margin-left: 27px"
										>
											<span
												class="flex absolute justify-center items-center bg-orange rounded-full left-4"
												style="width: 30px; height: 30px"
											>
												<span
													class="bg-white rounded-full text-orange text-2xl text-center font-bold"
													style="width: 28px; height: 28px"
													>?</span
												>
											</span>
											<div class="bg-gray-100 p-5 rounded-xl shadow">
												<h3
													class="mb-2 text-lg font-semibold text-gray-900 dark:text-white leading-4"
												>
													Weitere Fragen? Kontaktieren Sie uns und wir
													unterstützen Sie gern bei Ihrer Auktion!
												</h3>
												<div class="flex justify-start pr-4 pt-2">
													<img :src="auctionThumbUrl" />
													<div>
														<p class="pb-2 ml-4 mt-3 text-base font-medium">
															Georg Schulze-Ardey
															<br />+49 (0) 152 519 147 16 <br /><a
																href="mailto:info@cropspot.com"
																>info@cropspot.com</a
															>
														</p>
													</div>
												</div>
											</div>
										</li>
									</ol>
								</div>
							</div>
						</div>
						<div class="bg-gray-100 p-6 flex justify-end">
							<div>
								<ui-button
									type="primary"
									v-on:click="close()"
									label="zurück"
								></ui-button>
							</div>
						</div>
					</slot>
				</div>
			</transition>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			open: false,
		};
	},
	mounted() {
		this.open = true;
	},
	computed: {
		getBackgroundCSS: () =>
			"background:url(" +
			window.baseUrl +
			"/images/auction-info-header.jpg); background-size: cover",
		//getBoxBackgroundCSS: () => "background:url(" + window.baseUrl + "/images/auction-info-bubble-bg.svg) bottom right no-repeat;",
		auctionHammerUrl() {
			return window.baseUrl + "/images/auction-hammer-orange.svg";
		},
		auctionThumbUrl() {
			return window.baseUrl + "/images/auction_info_modal_georg.png";
		},
	},
	methods: {
		close() {
			//this.$emit('close');
			let ref = this.$refs.overlay,
				that = this;
			setTimeout(function () {
				that.$emit("close");
			}, 300);
			this.$nextTick(function () {
				this.open = false;
			});
		},
		getBoxBackgroundCSS(color = "") {
			return (
				"background:url(" +
				window.baseUrl +
				"/images/auction-info-bubble-bg" +
				(color !== "" ? "-" + color : "") +
				".svg) bottom right no-repeat;"
			);
		},
	},
};
</script>
